// Only same-site paths may be used as a post-login destination. Without this,
// /login?redirect=https://evil.example would turn our login page into a
// phishing relay ("sign in, then we send you to the attacker").
export default function safeRedirect(value) {
  if (typeof value !== 'string') return null;
  if (!value.startsWith('/')) return null;          // absolute URLs, javascript:, etc.
  if (value.startsWith('//') || value.startsWith('/\\')) return null;  // protocol-relative
  return value;
}
